export const CombinedMonths = [
  { id: '01', title: 'اسفند - فروردین' },
  { id: '02', title: 'فروردین - اردیبهشت' },
  { id: '03', title: 'اردیبهشت - خرداد' },
  { id: '04', title: 'خرداد - تیر' },
  { id: '05', title: 'تیر - مرداد' },
  { id: '06', title: 'مرداد - شهریور' },
  { id: '07', title: 'شهریور - مهر' },
  { id: '08', title: 'مهر - آبان' },
  { id: '09', title: 'آبان - آذر' },
  { id: '10', title: 'آذر - دی' },
  { id: '11', title: 'دی - بهمن' },
  { id: '12', title: 'بهمن - اسفند' },
];

export const Years = [
  { id: 1402, title: '1402' },
  { id: 1403, title: '1403' },
  { id: 1404, title: '1404' },
  { id: 1405, title: '1405' },
  { id: 1406, title: '1406' },
  { id: 1407, title: '1407' },
  { id: 1408, title: '1408' },
  { id: 1409, title: '1409' },
  { id: 1410, title: '1410' },
  { id: 1411, title: '1411' },
  { id: 1412, title: '1412' },
  { id: 1413, title: '1413' },
  { id: 1414, title: '1414' },
];
